<canvas #snowCanvas class="snow-canvas"></canvas>
